module.exports = __webpack_public_path__ + "static/media/model123.6b17ba7a.glb";